import { useEffect, useEffectEvent } from "react";
import sseRest from "../../rest/sseRest";

export const reconnectEventChannel = "RECONNECT_CHANNEL";

export const useSse = (eventType, callback) => {
    // non-reactive: a new callback must not tear down and re-open the subscription
    const onEvent = useEffectEvent(e => callback(JSON.parse(e.data)));

    useEffect(() =>
        sseRest.on(eventType, onEvent)
    , [eventType]);
};
